import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'Multi-Selector',

  componentName: 'MultiSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      selectList: []
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        filterable: true,
        placeholder: '请选择'
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  methods: {
    addSelectItem: function addSelectItem(val) {
      this.selectList.push({
        value: val
      });
    },
    handleAdd: function handleAdd() {
      if (this.selectList.length >= 5) {
        this.$message.warning('可配置安装点，不能超过5个');
        return;
      }
      this.addSelectItem('');
    },
    handleDel: function handleDel(index) {
      this.selectList.splice(index, 1);
    },
    getListValue: function getListValue() {
      return this.selectList.filter(function (item) {
        return item.value !== '';
      }).map(function (item) {
        return item.value;
      }).join();
    },
    handleChange: function handleChange() {
      if (this.innerConfig.prop) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue[this.innerConfig.prop] = this.getListValue();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (this.formValue[this.innerConfig.prop]) {
      var list = this.formValue[this.innerConfig.prop].split(',');
      list.forEach(function (value) {
        _this.addSelectItem(value);
      });
      //
    } else {
      this.addSelectItem('');
    }
  }
};